@if (isLoading) {
<div class="column is-12" style="display: flex; justify-content: center; margin-top: 100px">
  <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner" />
</div>
} @else {
<div class="container-fluid header-container">
  <div class="header">
    <div class="title-wrap">
      <h1 [routerLink]="['/declarations']" class="title"
        [title]="declaration ? declaration.name + ' - ' + clientDisplayName : ''">
        <fa-icon class="back-icon" [icon]="faChevronLeft"></fa-icon>
        @if (declaration) {
        {{ declaration.name }} - {{ clientDisplayName }}
        }
      </h1>
      <h1 class="title-tag">
        @if (declaration && declaration.status === "FINISHED") {
        <span class="tag finalized"><fa-icon [icon]="faCircle"></fa-icon>Realizada</span>
        } @else if (declaration.status === "PROGRESS") {
        <span class="tag pending"><fa-icon [icon]="faCircle"></fa-icon>En progreso</span>
        } @else if (declaration.status === "NOT_APPLICABLE") {
        <span class="tag not-applicable"><fa-icon [icon]="faCircle"></fa-icon>No procede</span>
        }
        @if (declaration?.createdAt) {
        <span class="tag tag-date">Creada: {{ declaration.createdAt | utcDate:'dd/MM/yyyy' }}</span>
        }
        @if (hasContractNotifications()) {
        <a class="contract-warning-badge" (click)="openContractObservationsModal()" title="Avisos de la declaración">
          <fa-icon [icon]="faTriangleExclamation"></fa-icon>
        </a>
        }
      </h1>
      <!-- Botón de comentarios del contrato -->

      @if (
      declaration.status === "NOT_APPLICABLE" ||
      declaration.status === "FINISHED"
      ) {
      <!-- <button style="margin:30px" class="button reopen-button"  (click)="openReactivateModal()">
                        <fa-icon style="margin-right: 10px;" [icon]="faRotateLeft"></fa-icon>
                        Reactivar
                    </button> -->
      }
    </div>

    <div class="header-actions">
      <div class="responsible-select">
        <p-dropdown [options]="responsibles" [(ngModel)]="declaration.responsible.id" optionValue="id"
          optionLabel="name" placeholder="Seleccionar responsable" (onChange)="setResponsible($event)"
          [readonly]="isBlocked" [disabled]="isBlocked" [emptyFilterMessage]="'No se encontraron resultados'" />
      </div>
      <div>
        <p-menu #menu [model]="actionMenuItems" [popup]="true" [appendTo]="'body'">
          <ng-template pTemplate="item" let-item>
            <a class="p-menuitem-link" (click)="item.command()">
              <span class="p-menuitem-icon">
                <fa-icon [icon]="item.icon"></fa-icon>
              </span>
              <span class="p-menuitem-text">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
        <button class="button is-secondary actions-button" aria-label="Acciones" (click)="menu.toggle($event)">
          <span class="button-content">
            <fa-icon [icon]="faGear"></fa-icon>
            <span>Acciones</span>
            <fa-icon [icon]="faChevronDown" class="chevron-icon"></fa-icon>
          </span>
        </button>
      </div>

      <!-- <div class="column is-1">
                    <button class="subrayado is-pulled-right" (click)="showAllFases()">                                
                        {{ allExpanded ? 'Contraer todo' : 'Expandir todo' }}
                    </button>
        
                </div> -->
    </div>

    <!-- <div>
                @if(declaration && declaration.status === "FINISHED" && isOnPeriod()) {
                    <button class="reopen-button button is-pulled-right" (click)="setToProgress()">                                
                        Reabrir declaración
                    </button>
                }
                @if(declaration && declaration.dateLimit) {
                    <span class="date">Fecha límite: {{declaration.dateLimit | date:'dd/MM/yyyy'}}</span>
                }
            </div> -->
  </div>
</div>
<div class="container-fluid filters">
  @if (declaration) {
  <div class="select-container">
      <div class="form-container presentation-type-input" [title]="declaration.presentationType || ''">
        <span class="label">Tipo de presentación</span>
        <p-dropdown [options]="declaration.model.availableTypePresentations" [(ngModel)]="declaration.presentationType"
          placeholder="Seleccionar tipo de presentación" (onChange)="setPresentation($event)" class="dropdown"
          [variant]="isPresentationChanged ? 'filled' : 'outlined'" [readonly]="isBlocked"
          [disabled]="isPresentationDisabled || isBlocked" [emptyFilterMessage]="'No se encontraron resultados'" />
      </div>
      <div class="form-container" [ngStyle]="{ display: isAccountHidden ? 'none' : '' }">
        <span class="label">Cuenta bancaria</span>
        <div class="account-input-container">
          <p-inputMask class="search-input" [ngClass]="{ 'account-changed': isAccountChanged }"
            [(ngModel)]="declaration.bankAccount" mask="aa99 9999 9999 9999 9999 9999" autoClear="false"
            (change)="setAccount($event)" (onInput)="onAccountChange($event)" placeholder="Cuenta bancaria"
            [disabled]="isAccountDisabled || isBlocked" [variant]="isAccountChanged ? 'filled' : 'outlined'"
            [readonly]="isBlocked" />
          <fa-icon class="refresh-icon" [icon]="faRotateLeftThin" (click)="resetAccount(originalBankAccount)"></fa-icon>
        </div>
      </div>
      <div class="form-container" [ngStyle]="{ display: isNRCHidden || !isDynamic ? 'none' : '' }">
        <span class="label">NRC</span>
        <div class="account-input-container">
          <input  class="search-input"  pInputText
            [(ngModel)]="declaration.nrc" (change)="setNRC($event)" (input)="onNRCChange($event)" placeholder="NRC"
            [disabled]="isBlocked" [variant]="isNRCChanged ? 'filled' : 'outlined'" [readonly]="isBlocked" />
        </div>
      </div>
  </div>
  <app-declaration-phases [isBlocked]="isBlocked" [phases]="declaration.phases" [isDynamic]="isDynamic"
    [isAccountingModel]="declaration.model.department === 'ACCOUNTING'" [isLaborModel]="declaration.model.department === 'LABOR'" [isMultiple]="1"
    [format]="declaration.presentationType" [bankAccount]="declaration.bankAccount"
    (closeEvent)="getData(declaration.id)" (commentEvent)="commentAdd($event)" (disableBankAccountAndPresentation)="
          disableBankAccountAndPresentation($event)
        " (taskSelected)="disableTasksOnTaskChange()"
    (bankAccountConfirmationStatusChange)="onBankAccountConfirmationChange($event)"></app-declaration-phases>
  <div>
    <h2 class="subtitle">Comentarios</h2>
    @if (!isBlocked) {
    <form [formGroup]="commentForm" (ngSubmit)="commentAdd()">
      <div class="card new-comment">
        <span class="user-name">{{ user.name }}</span>
        <textarea class="textarea" formControlName="comment" placeholder="Escribe aqui tu comentario"
          maxlength="500"></textarea>
        <hr />
        <button class="comment-button button is-pulled-right" type="submit" [disabled]="!commentForm.valid">
          Comentar
        </button>
      </div>
    </form>
    }
    @if (this.observations.length > 0) {
    <div>
      @for (obs of observations; track obs.id) {
      <div class="comment-container">
        <div>
          <span class="user-name">{{ obs.executor.name }}</span>
        </div>
        <span class="date-text">{{
          obs.created_at | utcDate
          }}</span>
        <p class="comment">{{ obs.comment }}</p>
      </div>
      }
    </div>
    <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"></div>
    }
  </div>
  } @else {
  <div class="skeleton-block"></div>
  <div class="skeleton-lines">
    <div></div>
    <div></div>
    <div></div>
  </div>
  }
</div>
@if (declaration) {
@if (
allPhasesSelected() &&
!isBlocked &&
declaration.status !== "NOT_APPLICABLE" &&
declaration.status !== "FINISHED"
) {
<div class="fab-buttons">
  <button class="button fab-exit" [routerLink]="['/declarations']">
    Salir
  </button>
  <button class="button fab-confirm" (click)="setToFinished()">
    Finalizar
  </button>
</div>
}
}
}

@if (showCommentModal) {
<app-comment-modal [isStatus]="true" (closeEvent)="closeCommentModal()" (commentEvent)="setToNoProceed($event)"
  #commentModal></app-comment-modal>
}

@if (showReactivateModal) {
<app-comment-modal [isReactivate]="true" [isStatus]="true" (closeEvent)="closeReactivateModal()"
  (commentEvent)="setToProgress($event)" #commentModal></app-comment-modal>
}

@if (showMultipleExecutorsModal) {
<app-multiple-executors-modal [phases]="declaration.phases" (closeEvent)="closeMultipleExecutorsModal()"
  (saveEvent)="onMultipleExecutorsSave($event)"></app-multiple-executors-modal>
}

<!-- Modal de observaciones del contrato -->
@if (showContractObservationsModal) {
<div class="modal is-active">
  <div class="modal-background" (click)="closeContractObservationsModal()"></div>
  <div class="modal-card contract-observations-modal">
    <button class="modal-close-button" (click)="closeContractObservationsModal()" type="button">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
    <section class="modal-card-body">
      <h3 class="modal-title">Avisos de la declaración</h3>

      <!-- Lista de observaciones (solo notificaciones) -->
      <div class="observations-list">
        @if (contractObservations.length > 0) {
        @for (obs of contractObservations; track obs.id) {
        <div class="observation-item">
          <div class="observation-header">
            <div class="observation-info">
              <strong>{{ obs.user?.name }}</strong>
              <span class="observation-date">{{
                obs.created_at | utcDate
                }}</span>
              <span class="tag is-warning">Aviso en declaración</span>
            </div>
          </div>
          <p class="observation-comment">{{ obs.comment }}</p>
        </div>
        }
        } @else {
        <p class="no-observations">No hay avisos</p>
        }
      </div>

      <!-- Formulario para añadir nueva observación (solo si está en PROGRESS) -->
      @if (declaration?.status === "PROGRESS") {
      <div class="add-observation-section">
        <form [formGroup]="contractObservationForm" (ngSubmit)="addContractObservation()">
          <div class="field">
            <label class="label">Añadir aviso</label>
            <textarea
              pInputTextarea
              [autoResize]="true"
              formControlName="comment"
              rows="3"
              class="textarea observations-field"
              placeholder="Escribe tu comentario..."
              maxlength="500"
            ></textarea>
          </div>
          <div class="buttons-container-right">
            <button class="button cancel-button" type="button" (click)="closeContractObservationsModal()">
              Cerrar
            </button>
            <button class="button save-button" type="button" (click)="addContractObservation()"
              [disabled]="!contractObservationForm.valid">
              Añadir
            </button>
          </div>
        </form>
      </div>
      }
    </section>
  </div>
</div>
}